export default () => ({
  started: false,
  playing: false,
  muted: false,

  play() {
    const video = this.$refs.video as HTMLVideoElement | undefined
    if (!video) return

    if (!video.dataset.loaded) {
      video.dataset.loaded = 'true'

      const webm = document.createElement('source')
      webm.type = 'video/webm'
      webm.src = video.dataset.srcWebm!

      const mp4 = document.createElement('source')
      mp4.type = 'video/mp4'
      mp4.src = video.dataset.srcMp4!

      video.append(webm, mp4)
      video.load()
    }

    video.muted = this.muted
    video.play().catch(() => {})
    this.started = true
    this.playing = true
  },

  togglePlay() {
    const video = this.$refs.video as HTMLVideoElement | undefined
    if (!video) return

    if (video.paused) {
      video.play().catch(() => {})
      this.playing = true
    } else {
      video.pause()
      this.playing = false
    }
  },

  toggleMute() {
    const video = this.$refs.video as HTMLVideoElement | undefined
    if (!video) return

    this.muted = !this.muted
    video.muted = this.muted
  },

  onEnded() {
    this.started = false
    this.playing = false
  },
})
